import React, { ReactElement } from "react"
import styled from "styled-components"

interface StyledInputProps {
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  label?: string
  required?: boolean
  width?: string
  height?: string
  disabled?: boolean
}

const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  width: ${props => props.width || "100%"};
`

const Label = styled.label`
  font-size: 10px;
  color: #2c3e50;
  margin-bottom: 2px;
  display: block;
`

const Input = styled.input<{ height?: string }>`
  background-color: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px !important;
  font-size: 14px;
  padding: 10px 12px;
  height: ${props => props.height || "auto"};
  transition: all 0.2s ease;
  outline: none;
  font-family: Poppins-Regular;

  &::placeholder {
    color: #999;
    font-size: 14px;
  }

  &:focus {
    border-color: #3498db;
  }

  &:hover:not(:focus) {
    border-color: #c1c7cd;
  }

  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
    opacity: 0.7;
  }
`

export default function StyledInput({
  value = "",
  onChange,
  placeholder,
  label,
  required = false,
  width,
  height,
  disabled = false,
}: StyledInputProps): ReactElement {
  return (
    <InputContainer width={width}>
      {label && (
        <Label>
          {label}
          {required && <span style={{ color: "#e74c3c" }}>*</span>}
        </Label>
      )}
      <Input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        height={height}
        disabled={disabled}
        required={required}
      />
    </InputContainer>
  )
}
